// Controllers load when their identifier first appears on the page (in a
// data-controller attribute), each in its own chunk with the libraries only it
// uses, so a page downloads only the code it runs. Hand-maintained: add a new
// controller to this map (bin/rails stimulus:manifest:update would rewrite this
// file as eager imports).

import { application } from "./application"

const controllers = {
  "attorneys-table": () => import("./attorneys_table_controller"),
  "batch-ingest-table": () => import("./batch_ingest_table_controller"),
  "case-analysis-form": () => import("./case_analysis_form_controller"),
  "case-analysis-history": () => import("./case_analysis_history_controller"),
  "case-analysis-history-table": () => import("./case_analysis_history_table_controller"),
  "case-analysis-progress": () => import("./case_analysis_progress_controller"),
  "case-analysis-stream": () => import("./case_analysis_stream_controller"),
  "case-chat-composer": () => import("./case_chat_composer_controller"),
  "case-chat-stream": () => import("./case_chat_stream_controller"),
  "case-chat-user-prompt": () => import("./case_chat_user_prompt_controller"),
  "case-courts-table": () => import("./case_courts_table_controller"),
  "case-document": () => import("./case_document_controller"),
  "case-document-associations-table": () => import("./case_document_associations_table_controller"),
  "case-documents-index": () => import("./case_documents_index_controller"),
  "case-documents-table": () => import("./case_documents_table_controller"),
  "case-files": () => import("./case_files_controller"),
  "case-parties-table": () => import("./case_parties_table_controller"),
  "case-research-start": () => import("./case_research_start_controller"),
  "case-source-pdf": () => import("./case_source_pdf_controller"),
  "case-strategies-table": () => import("./case_strategies_table_controller"),
  "case-strategy-form": () => import("./case_strategy_form_controller"),
  "case-strategy-picker": () => import("./case_strategy_picker_controller"),
  "cases-table": () => import("./cases_table_controller"),
  "chat-messages": () => import("./chat_messages_controller"),
  "court-select": () => import("./court_select_controller"),
  "courtlistener-research": () => import("./courtlistener_research_controller"),
  "courts-table": () => import("./courts_table_controller"),
  "data-tables": () => import("./data_tables_controller"),
  "discovery-production-table": () => import("./discovery_production_table_controller"),
  "download-archive": () => import("./download_archive_controller"),
  "generated-pdfs-table": () => import("./generated_pdfs_table_controller"),
  "law-firm-cases-table": () => import("./law_firm_cases_table_controller"),
  "law-firms-table": () => import("./law_firms_table_controller"),
  "legal-authorities-index": () => import("./legal_authorities_index_controller"),
  "legal-authorities-table": () => import("./legal_authorities_table_controller"),
  "log-action": () => import("./log_action_controller"),
  "navigation": () => import("./navigation_controller"),
  "parties-table": () => import("./parties_table_controller"),
  "pleadings-table": () => import("./pleadings_table_controller"),
  "research-copy": () => import("./research_copy_controller"),
  "research-index": () => import("./research_index_controller"),
  "research-layout": () => import("./research_layout_controller"),
  "research-list": () => import("./research_list_controller"),
  "research-thread": () => import("./research_thread_controller"),
  "saved-collapse": () => import("./saved_collapse_controller"),
  "windowed-list": () => import("./windowed_list_controller"),
}

const loading = new Set()

function load(identifier) {
  if (loading.has(identifier) || !controllers[identifier]) return
  loading.add(identifier)
  controllers[identifier]()
    .then((module) => application.register(identifier, module.default))
    .catch((error) => {
      loading.delete(identifier)
      console.error(`The ${identifier} controller failed to load`, error)
    })
}

function scan(node) {
  if (node.nodeType !== Node.ELEMENT_NODE) return
  const elements = node.matches("[data-controller]") ? [node] : []
  elements.push(...node.querySelectorAll("[data-controller]"))
  elements.forEach((element) => {
    (element.getAttribute("data-controller") || "").split(/\s+/).forEach((identifier) => {
      if (identifier) load(identifier)
    })
  })
}

scan(document.documentElement)
new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === "attributes") scan(mutation.target)
    else mutation.addedNodes.forEach(scan)
  })
}).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ["data-controller"] })
